import axios, { type AxiosResponse } from 'axios'

const loadMore = (
  wrapperClass: string,
  btnClass: string,
  targetClass: string
) => {
  const wrapper = document.querySelector<HTMLDivElement>(wrapperClass)
  const btn = document.querySelector<HTMLButtonElement>(btnClass)
  const target = document.querySelector<HTMLDivElement>(targetClass)

  if (!btn || !wrapper || !target) return

  const setIsLoading = () => {
    btn.classList.remove('is-loading')
    btn.disabled = false
    btn.textContent = INITIAL_CONTENT
    isLoading = false
  }

  const setIsNotLoading = () => {
    btn.classList.add('is-loading')
    btn.disabled = true
    btn.textContent = 'Ładowanie'
    isLoading = true
  }

  const cleanup = () => {
    if (page > maxPages) return wrapper.remove()
    setIsLoading()
  }

  const handlePostLoad = (res: AxiosResponse<unknown, unknown>) => {
    if (typeof res.data !== 'string') return

    target.insertAdjacentHTML('beforeend', res.data)
    page++
  }

  const loadPosts = () => {
    if (isLoading) return

    setIsNotLoading()

    const data = new FormData()
    data.append('action', 'frajda_load_more')
    data.append('_ajax_nonce', nonce)
    data.append('page', page.toString())
    data.append('postsPerPage', postPerPage.toString())
    data.append(
      'isSearch',
      document.body.classList.contains('search-results') ? 'yes' : 'no'
    )

    axios
      .post(ajaxurl, data)
      .then(handlePostLoad)
      .catch(console.log)
      .finally(cleanup)
  }

  const { ajaxurl, nonce } = FRAJDA_LM
  let page = 2
  let isLoading = false
  const maxPages = toInt(target.dataset.mp, 1)
  const postPerPage = toInt(target.dataset.ppp, 1)
  const INITIAL_CONTENT = btn.textContent

  btn.addEventListener('click', loadPosts)
}

const toInt = (num: string | undefined, defaultNum: number) => {
  if (typeof num !== 'string') return defaultNum

  const parsed = parseInt(num)
  return isNaN(parsed) ? defaultNum : parsed
}

export default loadMore
